const appbasePrefs = '{{APPBASE_PREFERENCES}}';

export default appbasePrefs;
